import { useCallback, useEffect, useRef, useState } from "react";

type AudioProps = {
  loop?: boolean;
  onend?: () => void;
};
const useSound = (audioSource: string, audioProps?: AudioProps) => {
  const audioPlayer = useRef<HTMLAudioElement>(undefined);
  const [playing, setPlaying] = useState(false);

  const onEndAudio = useCallback(() => {
    if (audioProps?.onend) {
      audioProps.onend();
    }
    setPlaying(false);
  }, [audioProps]);

  // resetAudio if audioSource/props changes
  useEffect(() => {
    if (audioPlayer.current) {
      audioPlayer.current.pause();
      audioPlayer.current.currentTime = 0;
      audioPlayer.current.removeEventListener("ended", onEndAudio);
    }
    audioPlayer.current = new Audio(audioSource);
    audioPlayer.current.loop = audioProps?.loop || false;
    audioPlayer.current.addEventListener("ended", onEndAudio);
  }, [audioSource, onEndAudio, audioProps?.loop]);

  // play/pause audio
  useEffect(() => {
    if (!audioPlayer.current) return;
    if (playing) {
      audioPlayer.current.play();
    } else {
      audioPlayer.current.pause();
    }
  }, [playing]);

  const playSound = () => {
    setPlaying(true);
  };

  const pauseSound = () => {
    setPlaying(false);
  };

  return {
    isPlaying: playing,
    play: playSound,
    pause: pauseSound
  };
};

export default useSound;
